export const PUSH_TOKEN_LOCAL_STORAGE_KEY = "pushToken";
